module.exports = __webpack_public_path__ + "img/tcf_3.11f37a2e.png";